<template>
  <span class="t-tooltip">
    <transition :name="transitionName">
      <span
        v-show="showTooltip"
        ref="tooltip"
        role="tooltip"
        class="t-tooltip__tooltip"
        :class="[
          `t-tooltip__tooltip--${type}`,
        ]"
      >
        <span v-if="label">{{ label }}</span>
        <slot name="html" />
        <span data-popper-arrow />
      </span>
    </transition>
    <span
      ref="trigger"
      class="t-tooltip__trigger"
      @mouseover="show"
      @mouseleave="hide"
    >
      <slot aria-describedby="tooltip" />
    </span>
  </span>
</template>

<script>
import { createPopper } from '@popperjs/core';
import ColorTypeMixin from '../../mixins/ColorTypeMixin';
import { componentVariants, tooltipPositionOptions } from '../../enums';

export default {
  name: 't-tooltip',

  mixins: [ColorTypeMixin],

  mounted() {
    this.initializePopper();
  },

  props: {
    type: {
      default: componentVariants.DARK,
    },
    label: {
      type: String,
    },
    position: {
      type: String,
      default: tooltipPositionOptions.TOP,
      validator: (value) => Object.values(tooltipPositionOptions).includes(value),
    },
    fixed: Boolean,
    animated: Boolean,
  },

  data: () => ({
    showTooltip: false,
    popperInstance: null,
  }),

  computed: {
    transitionName() {
      return this.animated ? 't-tooltip-transition' : '';
    },

    hasData() {
      return !!this.label || !!this.$slots.html;
    },
  },

  methods: {
    initializePopper() {
      this.popperInstance = createPopper(this.$refs.trigger, this.$refs.tooltip, {
        placement: this.position,
        modifiers: [
          {
            name: 'offset',
            options: {
              offset: [0, 8],
            },
          },
        ],
      });
      if (this.fixed) {
        this.show();
      }
    },

    show() {
      if (this.hasData) {
        this.showTooltip = true;
        this.popperInstance.update();
      }
    },

    hide() {
      if (!this.fixed) {
        this.showTooltip = false;
      }
    },
  },

  watch: {
    label(val) {
      console.log(val);
    },
  },
};
</script>
